'use strict'

module.exports = {
  gossipsub: require('libp2p-gossipsub')
}
